import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';

export default function ModalFooter({
  children,
  submit,
  submitLoading,
  text,
  buttonDisabled = false,
}) {
  const { t } = useTranslation();
  return (
    <div className={"d-flex justify-content-between px-4 py-3"}>
      <div>{children}</div>
      <div
        onClick={() => {
          if (!buttonDisabled && submit && !submitLoading) submit();
        }}
        className={"d-flex justify-content-center align-items-center"}
        style={{
          color: buttonDisabled ? "#CCC" : "#52A035",
          backgroundColor: submitLoading ? "#CCC" : "#FFF",
          borderRadius: "5px",
          padding: "6px 12px",
          cursor: submitLoading || buttonDisabled ? "not-allowed" : "pointer",
          userSelect: "none",
          border: `${buttonDisabled ? "#CCC" : "#52A035"} 1px solid`,
        }}
      >
        {!text && (
          <FontAwesomeIcon
            icon={faSave}
            size={"lg"}
            color={buttonDisabled ? "#CCC" : "#52A035"}
            className={"me-2"}
          />
        )}
        <div>{text ? text : t('common.save')}</div>
      </div>
    </div>
  );
}
